<template>
  <div class="page-system-setting">
    <div class="base-setting">
      <ym-cell title="账号安全"
               is-link
               :border="false"
               :to="{name: 'AccountSecurity'}"
      >
      </ym-cell>
      <ym-cell title="自动连续播放"
               is-link
               :border="false"
               :to="{name: 'AutoContinuousPlay'}"
      >
      </ym-cell>
      <ym-cell title="定时关闭"
               is-link
               :border="false"
               :to="{name: 'TimedOff'}"
      >
      </ym-cell>
      <ym-cell title="提醒设置"
               is-link
               :border="false"
               :to="{name: 'SubscribeSetting'}"
      >
      </ym-cell>
    </div>
    <div class="footer ym-mw-component-fixed-max"
         v-if="auth != null && auth !== ''"
    >
      <ym-button class="logout-btn"
                 type="danger"
                 plain
                 size="large"
                 @click="handleLogout"
      >
        退出登录
      </ym-button>
    </div>
  </div>
</template>

<script>
  import { Cell, Button } from '@ymba/ym-ui';
  import { mapActions, mapGetters } from 'vuex';
  import { getMyAccountInfo } from '@/services/user';
  import { setToLocalStorage } from '@/utils';

  export default {
    name: 'SystemSetting',
    metaInfo: {
      title: '系统设置',
    },
    components: {
      'ym-cell': Cell,
      'ym-button': Button,
    },
    computed: {
      ...mapGetters([
        'auth',
      ]),
    },
    methods: {
      ...mapActions([
        'Logout',
      ]),
      async handleLogout() {
        const data = await getMyAccountInfo();
        setToLocalStorage('last-login-mobile', data.mobile);
        await this.Logout();
        const route = { name: 'Mine' };
        this.$router.replace(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-system-setting {
    min-height: 100%;
    background-color: @color-white;
  }

  .features-setting {
    padding-top: @size-small;
    background: @background-color-base;
  }

  .footer {
    position: fixed;
    bottom: 20px;
    padding: @size-base;
  }
</style>
